// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.SatelliteAttachmentMetadataStatusType

export enum SatelliteAttachmentMetadataStatusType {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
}

export const SatelliteAttachmentMetadataStatusType_values = [
  SatelliteAttachmentMetadataStatusType.COMPLETE,
  SatelliteAttachmentMetadataStatusType.INCOMPLETE,
] as const;
